import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card';
import { format } from 'date-fns';
import React from 'react';
import { getStatusInfo } from '../utils/certificateStatusUtils';

const TCEBPCertificateVerification = ({ certificate }) => {
   const isExpired = certificate.expiryDate ? new Date(parseInt(certificate.expiryDate)) < new Date() : false;
   const statusInfo = getStatusInfo(certificate.certificateStatus, isExpired);

   const formatDate = (timestamp) => {
      if (!timestamp) return null;
      return format(new Date(parseInt(timestamp)), 'MMMM d, yyyy');
   };

   // Handle cases where tcebpCertificateData might be undefined
   const certificateData = certificate.tcebpCertificateData || {};

   return (
      <div className="space-y-6">
         <div className="text-center mb-8">
            <statusInfo.icon className="mx-auto h-12 w-12 text-gray-600" />
            <h2 className="mt-4 text-3xl font-bold text-gray-900">
               Tree Cutting and Earth-Balling Permit Verification
            </h2>
         </div>

         <Card className="p-6 mb-6">
            <div className="flex justify-between items-center mb-6">
               <h3 className="text-lg font-semibold">Certificate Status</h3>
               <Badge className={statusInfo.color}>
                  {statusInfo.label}
               </Badge>
            </div>

            <div className="space-y-4">
               <div>
                  <h4 className="text-sm font-medium text-gray-500">Certificate Number</h4>
                  <p className="text-lg">{certificate.certificateNumber}</p>
               </div>

               <div>
                  <h4 className="text-sm font-medium text-gray-500">Applicant Information</h4>
                  <p className="text-lg">{certificateData.applicantName}</p>
                  <p className="text-gray-600">{certificateData.applicantAddress}</p>
                  <p className="text-gray-600">Contact: {certificateData.contactNumber}</p>
               </div>

               <div>
                  <h4 className="text-sm font-medium text-gray-500">Project Details</h4>
                  <p><span className="font-medium">Project Name:</span> {certificateData.projectName}</p>
                  <p><span className="font-medium">Location:</span> {certificateData.projectLocation}</p>
                  <p><span className="font-medium">Purpose:</span> {certificateData.purpose}</p>
               </div>

               <div>
                  <h4 className="text-sm font-medium text-gray-500">Tree Details</h4>
                  {certificateData.treesToCut && certificateData.treesToCut.length > 0 ? (
                     <div>
                        <h5 className="text-sm font-medium mt-2">Trees to Cut</h5>
                        <div className="mt-2 border rounded-md overflow-hidden">
                           <table className="min-w-full divide-y divide-gray-200">
                              <thead className="bg-gray-50">
                                 <tr>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Species</th>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Quantity</th>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Diameter</th>
                                 </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-gray-200">
                                 {certificateData.treesToCut.map((tree, index) => (
                                    <tr key={index}>
                                       <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{tree.species}</td>
                                       <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{tree.quantity}</td>
                                       <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{tree.diameter}</td>
                                    </tr>
                                 ))}
                              </tbody>
                           </table>
                        </div>
                     </div>
                  ) : (
                     <p className="text-gray-500 italic">No trees to cut specified</p>
                  )}

                  {certificateData.treesToEarthball && certificateData.treesToEarthball.length > 0 ? (
                     <div className="mt-4">
                        <h5 className="text-sm font-medium mt-2">Trees to Earth-ball</h5>
                        <div className="mt-2 border rounded-md overflow-hidden">
                           <table className="min-w-full divide-y divide-gray-200">
                              <thead className="bg-gray-50">
                                 <tr>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Species</th>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Quantity</th>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Diameter</th>
                                 </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-gray-200">
                                 {certificateData.treesToEarthball.map((tree, index) => (
                                    <tr key={index}>
                                       <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{tree.species}</td>
                                       <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{tree.quantity}</td>
                                       <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{tree.diameter}</td>
                                    </tr>
                                 ))}
                              </tbody>
                           </table>
                        </div>
                     </div>
                  ) : (
                     <p className="text-gray-500 italic">No trees to earth-ball specified</p>
                  )}
               </div>

               <div>
                  <h4 className="text-sm font-medium text-gray-500">Validity Period</h4>
                  <p><span className="font-medium">Issue Date:</span> {formatDate(certificate.dateIssued)}</p>
                  <p><span className="font-medium">Expiry Date:</span> {formatDate(certificate.expiryDate)}</p>
               </div>
            </div>
         </Card>
      </div>
   );
};

export default TCEBPCertificateVerification;
